import React, { useCallback } from "react";
import { InputCpfCnpj } from "areas/payment/inputCpfCnpj/InputCpfCnpj";
import { Trans } from "react-i18next";
import { OrientationType, ResolutionType, useScreenStore } from "application/contexts/screen/ScreenStore";
import styles from "./CpfStepLayout.module.scss";
import offlineRechargeStyles from "../../../offlineRecharge/OfflineRecharge.module.scss";

/**
 * Etapa de informar CPF (abertura de cartão).
 * Título no mesmo estilo das mensagens line1/line2 do fluxo (readCardMessage).
 */
export interface CpfStepLayoutProps {
  /** Callback ao confirmar o CPF. */
  onPressContinuar: (cpfOrCnpj?: string) => void;
  /** Se true, o usuário não pode pular (obrigatório informar CPF). */
  required?: boolean;
  /** Callback ao cancelar (ex.: voltar para leitura do cartão). Quando informado, o segundo botão exibe "Cancelar". */
  onPressCancel?: () => void;
}

export const CpfStepLayout: React.FC<CpfStepLayoutProps> = ({
  onPressContinuar,
  required = false,
  onPressCancel,
}) => {
  const { resolution, orientation } = useScreenStore();
  const isLandscape = orientation === OrientationType.LANDSCAPE;
  const fontSize = resolution === ResolutionType.FULL_HD ? 70 : isLandscape ? 36 : 50;
  const margin = resolution === ResolutionType.FULL_HD ? 150 : isLandscape ? 16 : 75;

  const handleConfirm = useCallback(
    (cpfOrCnpj?: string) => {
      onPressContinuar(cpfOrCnpj);
    },
    [onPressContinuar]
  );

  return (
    <div className={styles.container}>
      <div
        className={offlineRechargeStyles.readCardMessage}
        style={{ margin }}
      >
        <p style={{ fontSize }}>
          <Trans i18nKey="input_cpf_cnpj.title">
            Insira o documento de identificação para continuar
          </Trans>
        </p>
      </div>
      <div className={styles.inputWrapper}>
        <InputCpfCnpj
          required={required}
          onPressContinuar={handleConfirm}
          onPressCancel={onPressCancel}
          hideTitle
        />
      </div>
    </div>
  );
};

export default CpfStepLayout;
